import React, { useCallback, useEffect, useState } from "react";

import Skeleton from "@/components/dashboard/recommended/jobDescription/skeleton";

import { useRecommendedPageData } from "../";
import { useDashboardContext } from "../..";
import { DashboardContextProps, RecommendedPageContextProps } from "../types";
import { useJobDetails } from "./query";
import JobStatusCard from "./view";

const JobDescription = () => {
  const { isMobile }: DashboardContextProps = useDashboardContext();
  const {
    recommendedJobData,
    setRecommendedJobData,
  }: RecommendedPageContextProps = useRecommendedPageData();

  const [selectedData, setSelectedData] = useState<any>({
    jobId: "",
    kiwiJobId: "",
    id: "",
  });
  const [loader, setLoader] = useState(true);
  const [enableAPI, setEnableAPI] = useState({
    enableJobStatusFetch:
      !recommendedJobData.newDataLoader &&
      (selectedData?.jobId || selectedData?.id)
        ? true
        : false,
  });

  const { data: jobDetails } = useJobDetails(
    selectedData?.jobId || selectedData?.id,
    selectedData?.kiwiJobId,
    recommendedJobData?.profilePersonalDetails?.personalDetailSection
      ?.personalDetails?.uuid || "",
    recommendedJobData?.profilePersonalDetails?.isAutoRegistered || false,
    enableAPI.enableJobStatusFetch,
  );

  const mediaUrl =
    recommendedJobData.siteProps?.media_url || "media.foundit.in";

  const setLoaderOff = useCallback(() => {
    setTimeout(() => {
      setLoader(false);
      setTimeout(() => {
        document.body.style.overflow = "auto";
      }, 100);
    }, 200);
  }, [loader]);

  useEffect(() => {
    if (recommendedJobData.filterDisable) {
      setRecommendedJobData({
        ...recommendedJobData,
        jobDescIndex: { selectedIndex: isMobile ? undefined : 0 },
        filterDisable: false,
      });
    }
  }, [recommendedJobData.data]);

  useEffect(() => {
    if (!isMobile) {
      const recommendedJobDataNew =
        recommendedJobData.displayRecommendedData?.[
          !recommendedJobData.jobDescIndex?.selectedIndex
            ? 0
            : recommendedJobData.jobDescIndex?.selectedIndex
        ];
      setSelectedData(recommendedJobDataNew || {});
      setEnableAPI({
        enableJobStatusFetch:
          !recommendedJobData.newDataLoader &&
          (recommendedJobDataNew?.jobId || recommendedJobDataNew?.id)
            ? true
            : false,
      });
      if (
        selectedData?.id == recommendedJobDataNew?.id &&
        !recommendedJobData.newDataLoader
      ) {
        setLoaderOff();
      }
    }
  }, [recommendedJobData.jobDescIndex]);

  useEffect(() => {
    if (recommendedJobData.isLoadingJobDesc) {
      setLoader(true);
      document.body.style.overflow = "hidden";
    }
  }, [recommendedJobData.isLoadingJobDesc]);

  useEffect(() => {
    if (jobDetails) {
      setLoaderOff();
    }
  }, [jobDetails]);

  const jobStatusCardComponent = (
    <div>
      {loader || recommendedJobData.isLoadingJobDesc ? (
        <Skeleton isMobile={isMobile} />
      ) : (
        <div>
          <JobStatusCard
            selectedData={selectedData}
            jobDescData={{
              jobDetails,
              filterStatusPresent: recommendedJobData.filterStatusPresent,
            }}
            siteProps={recommendedJobData?.siteProps || {}}
            sitePropsProperties={recommendedJobData?.sitePropsProperties || {}}
            loader={loader}
            mediaUrl={mediaUrl}
            leftSideRef={recommendedJobData.leftSideRef}
            savedJobs={recommendedJobData.savedJobs || []}
            saveUnsaveJobHandler={recommendedJobData.saveUnsaveJobHandler}
          />
        </div>
      )}
    </div>
  );

  return jobStatusCardComponent;
};

export default React.memo(JobDescription);
